"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromptModalViewModel = exports.ModalActionModel = void 0;
const mobx_1 = require("mobx");
const FlagModel_1 = require("./FlagModel");
class ModalActionModel {
    constructor() {
        this.isActive = new FlagModel_1.FlagModel();
        this._currentAction = null;
        this.openModal = (action) => {
            this._currentAction = action;
            this.isActive.value = true;
        };
        this.closeModal = () => {
            this.isActive.value = false;
            this._currentAction = null;
        };
        this.runAction = async (cb, close = true, awaitAction = false) => {
            if (cb) {
                const promise = cb();
                if (awaitAction) {
                    await promise;
                }
            }
            if (close) {
                this.closeModal();
            }
        };
        (0, mobx_1.makeObservable)(this, {
            _currentAction: mobx_1.observable.ref,
            openModal: mobx_1.action,
            closeModal: mobx_1.action,
        });
    }
    get currentAction() { return this._currentAction; }
}
exports.ModalActionModel = ModalActionModel;
class PromptModalViewModel extends ModalActionModel {
    constructor() {
        super(...arguments);
        this.onConfirm = () => this.runAction(this.currentAction.onConfirm, true, this.currentAction.awaitActions);
        this.onReject = () => this.runAction(this.currentAction.onReject, true, this.currentAction.awaitActions);
    }
    get confirmColor() { return this.currentAction.confirmColor; }
    get rejectColor() { return this.currentAction.rejectColor; }
}
exports.PromptModalViewModel = PromptModalViewModel;
//# sourceMappingURL=PromptModal.js.map